import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './FollowUpSending.scss';
import { Spinner, Button, Modal } from 'react-bootstrap'; // Import Spinner
import { API } from '../data/API/API';
import { GetInvoiceList, GetInvoicePdf } from '../data/API/Pdfs';
import PdfTable from '../components/PdfTable/PdfTable'; // Import the PdfTable component
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faRedo, faTimesCircle, faCheckCircle, faTimes, faCheck, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

// Import the centralized status translations and icons
import { statusTranslation, statusIconColorMap } from '../lib/utils';
import InternalCommentsInline from '../components/InternalComments/InternalCommentsInline';
import InternalCommentsChatInline from '../components/InternalComments/InternalCommentsChat';
import InternalCommentsChatDock from '../components/InternalComments/InternalCommentsChatDock';
import { User } from '../data/API/User';

const FollowUpSending: React.FC = () => {
    const { sendingId } = useParams<{ sendingId: string }>();
    const [sendingData, setSendingData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [showInvoicesModal, setShowInvoicesModal] = useState(false);
    const [invoiceList, setInvoiceList] = useState<{
        pdfName: string;
        status?: number;
        invoiceNumber?: string;
        billingDate?: string;
        totalPrice?: number;
        sinfraAvtal?: number;
    }[]>([]); // Adjust the state type
    const [loadingInvoices, setLoadingInvoices] = useState(false); // Loading state for invoices
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Modal state for link reopening confirmation
    const [reopeningLinkLoading, setReopeningLinkLoading] = useState(false); // Loading state for reopening link
    const [showConfirmHandledModal, setShowConfirmHandledModal] = useState(false);
    const [isHandled, setIsHandled] = useState(false);
    const [memberLink, setMemberLink] = useState<{ consumed: boolean; expiration: string } | null>(null);
    const [currentUserKey,setCurrentUserKey] = useState('')
    const fetchSendingData = async () => {
        setLoading(true);
        try {
            const response = await API.Sendings.getSendingDetails(Number(sendingId));
            console.log(response,'VIKTIG')
            if (response) {
                setSendingData(response);
                setIsHandled(response.sendingDetails.isHandled);  // Set initial handling status

                // Set memberLink data
                setMemberLink({
                    consumed: response.memberLink.consumed,
                    expiration: response.memberLink.expiration
                });
                console.log('Sending data:', response);
            } else {
                console.error('No data returned from the API');
            }
        } catch (error) {
            console.error('Error fetching sending details:', error);
        } finally {
            await fetchCurrentUserKey()
            setLoading(false);
        }
    };
const fetchCurrentUserKey = async () => {
  const userName =   await User.GetUserName();
  console.log(userName);
  setCurrentUserKey(userName.username)

}

    // Call fetchSendingData in useEffect to fetch initial data
    useEffect(() => {
        if (sendingId) {
            fetchSendingData();
        }
    }, [sendingId]);

    // Function to handle fetching the list of invoices when opening the modal
    const handleOpenInvoicesModal = async () => {
        setShowInvoicesModal(true);
        setLoadingInvoices(true);
        try {
            if (sendingId) {
                // Fetch the invoice list with full details from the API
                const invoices = await GetInvoiceList(Number(sendingId));

                // Map the API response directly to the structure needed for PdfTable
                const mappedInvoices = invoices.map((invoice: any) => ({
                    pdfName: invoice.pdfName,
                    status: invoice.status,
                    invoiceNumber: invoice.invoiceNumber,
                    billingDate: invoice.billingDate,
                    totalPrice: invoice.totalPrice,
                    sinfraAvtal: invoice.sinfraAvtal
                }));

                setInvoiceList(mappedInvoices); // Set the list with the correct structure
            }
        } catch (error) {
            console.error('Error fetching invoice list:', error);
        } finally {
            setLoadingInvoices(false);
        }
    };

    // Function to handle clicking an invoice to download/view the PDF
    const handleInvoiceClick = async (fileName: string) => {
        try {
            const pdfBlob = await GetInvoicePdf(Number(sendingId), fileName); // Fetch PDF using sendingId and fileName
            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            window.open(pdfUrl); // Open the PDF in a new tab
        } catch (error) {
            console.error('Error fetching PDF file:', error);
        }
    };

    const handleDownloadAllPdfs = async () => {
        try {
            if (!invoiceList || invoiceList.length === 0) return;

            // Create a new zip file
            const zip = new JSZip();

            // Loop through each invoice and fetch the PDF blob
            for (const invoice of invoiceList) {
                const pdfBlob = await GetInvoicePdf(Number(sendingId), invoice.pdfName); // Fetch the PDF file
                zip.file(invoice.pdfName, pdfBlob); // Add each PDF to the zip
            }

            // Define the zip filename with Swedish and additional info
            const zipFileName = `${customerName}-${sendingId}-fakturor.zip`; // Custom name including member/customer and sendingId

            // Generate the zip file and trigger download
            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, zipFileName); // Download the zip file with the custom name
        } catch (error) {
            console.error('Error downloading all invoices:', error);
        }
    };

    // Function to handle reopening the link
    const handleReopenLink = async () => {
        setReopeningLinkLoading(true);
        try {
            const responseMessage = await API.Emails.reopenLink(Number(sendingId));
            alert(responseMessage); // Show success message

            // Re-fetch the sending details to update the status
            await fetchSendingData(); // Re-fetch the data to update the "Länk status"
        } catch (error) {
            if (error instanceof Error) {
                alert(`Error: ${error.message}`);  // Display the specific backend error message like "Länken är fortfarande aktiv"
            } else {
                alert('An unknown error occurred');  // Catch any other issues
            }
        } finally {
            setReopeningLinkLoading(false);
            setShowConfirmModal(false); // Close confirmation modal
        }
    };

    const openConfirmHandledModal = () => {
        setShowConfirmHandledModal(true);
    };

    const handleConfirmToggle = async () => {
        try {
            await handleToggleIsHandled();
        } finally {
            setShowConfirmHandledModal(false); // Close modal after confirmation
        }
    };

    const handleToggleIsHandled = async () => {
        try {
            // Toggle the `isHandled` status
            const newStatus = !isHandled;
            await API.Sendings.UpdateSendingHandledStatus(Number(sendingId), newStatus);
            setIsHandled(newStatus);  // Update state based on successful API call
            fetchSendingData(); // Refresh data to reflect any changes from the backend
        } catch (error) {
            console.error("Error updating IsHandled status:", error);
        }
    };

    const renderCorrectness = (value: boolean | null, label: string) => {
        let icon, color, text;

        if (value === true) {
            icon = faCheckCircle;
            color = 'correct';
            text = 'Ja';
        } else if (value === false) {
            icon = faTimesCircle;
            color = 'incorrect';
            text = 'Nej';
        } else {
            icon = faMinusCircle;
            color = 'na';
            text = 'N/A';
        }

        return (
            <div className="correctness-item">
                <span className="correctness-label">{label}</span>
                <span className={`correctness-badge ${color}`}>
                    <FontAwesomeIcon icon={icon} className="correctness-icon" />
                    {text}
                </span>
            </div>
        );
    };

    if (loading) {
        // Show spinner when loading
        return (
            <div className="center-spinner">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (!sendingData) {
        return <p>Error: No data found</p>;
    }

    // Access the correct nested data
    const { sendingDetails, logs } = sendingData;

    const {
        sendingId: fetchedSendingId,
        customerName,
        customerOrgId,
        sendingCreatedDate,
        sendingUpdatedDate,
        sendingStatus,
        sendingRecieverMail,
        supplierName,
        supplierOrgId,
        emailTemplateName,
        sendingEmailBody,
        sendingEmailSubject,
        period,
        endPeriod,
        amountCorrect,
        quantityCorrect,
        labelCorrect
    } = sendingDetails;

    const isLinkOpen = memberLink && !memberLink.consumed && new Date(memberLink.expiration) > new Date();

    return (
        <div className="followup-sending-page">
            <div className="follow-up-sending-header-container">
                <h1 className="follow-up-sending-header">Uppföljning {fetchedSendingId}</h1>
                <span className={`status-indicator ${isHandled ? 'handled' : 'unhandled'}`}>
                    <span className="status-icon">
                        <FontAwesomeIcon icon={isHandled ? faCheck : faTimes} />
                    </span>
                    {isHandled ? 'Slutförd' : 'Ej slutförd'}
                </span>
            </div>

            {/* Grid system for the sending details */}
            <div className="sending-details-grid">
                <div className="grid-item">
                    <h3>{customerName} - {customerOrgId}</h3>
                    <p className="description">Organisation</p>
                </div>
                <div className="grid-item">
                    <h3>{new Date(sendingCreatedDate).toLocaleDateString()}</h3>
                    <p className="description">Skickat</p>
                </div>
                <div className="grid-item">
                    <h3>
                        {period && endPeriod ? `${period} - ${endPeriod}` : period || "Period saknas"}
                    </h3>
                    <p className="description">Period</p>
                </div>

            </div>

            <div className="sending-details-grid">
                <div className="grid-item">
                    <h3>{supplierName} - {supplierOrgId}</h3>
                    <p className="description">Gällande motpart</p>
                </div>
                <div className="grid-item">
                    <h3>{statusTranslation[sendingStatus]} ({sendingStatus})</h3> {/* Use centralized statusTranslation */}
                    <p className="description">Status</p>
                </div>
                <div className="grid-item">
                    <h3>{new Date(sendingUpdatedDate).toLocaleDateString()}</h3>
                    <p className="description">Senast ändrad</p>
                </div>
            </div>

            <div className="sending-details-grid">
                <div className="grid-item">
                    <h3>{sendingRecieverMail}</h3>
                    <p className="description">Skickades till</p>
                </div>
                <div className="grid-item">
                    <h3>{emailTemplateName}</h3>
                    <p className="description">Använd e-postmall</p>
                </div>
                {/* Display link status */}
                <div className="grid-item">
                    <h3 style={{ color: isLinkOpen ? '#28a745' : '#dc3545' }}>
                        {isLinkOpen ? "Öppen" : "Stängd"}
                    </h3>
                    <p className="description">Länk status</p>
                </div>
            </div>
            <div className='sending-details-grid'>
             

            </div>

            <div className="historik-section">
                <div className="historik-header">
                    <h2>Historik</h2>

                    {/* Invoices Button with Icon */}
                    <button className="btn response-overview-button" onClick={handleOpenInvoicesModal}>
                        <FontAwesomeIcon icon={faFileInvoice} style={{ marginRight: '5px' }} />
                        Svar och fakturaöversikt
                    </button>

                    {/* Reopen Link Button with Icon */}
                    <button
                        className="btn reopen-link-button"
                        onClick={() => setShowConfirmModal(true)}  // Open the confirmation modal
                        disabled={!memberLink || (!memberLink.consumed && new Date(memberLink.expiration) > new Date())}  // Disable if link is open
                    >
                        <FontAwesomeIcon icon={faRedo} style={{ marginRight: '5px' }} />
                        Återöppna länk
                    </button>

                    <button className={`btn handled-button ${isHandled ? 'unhandled' : 'handled'}`} onClick={openConfirmHandledModal}>
                        <FontAwesomeIcon icon={isHandled ? faTimesCircle : faCheckCircle} style={{ marginRight: '5px' }} />
                        {isHandled ? 'Markera som ej slutförd' : 'Markera som slutförd'}
                    </button>
                </div>

                {Array.isArray(logs) && logs.length > 0 ? (
                    (() => {
                        const latestLogsByStatusAndTimestamp: { [statusTimestamp: string]: any } = {};

                        // Track unique logs by concatenating status and timestamp as a key
                        logs.forEach((log: any) => {
                            const logKey = `${log.status}-${new Date(log.timestamp).getTime()}`;
                            if (!latestLogsByStatusAndTimestamp[logKey]) {
                                latestLogsByStatusAndTimestamp[logKey] = log;
                            }
                        });

                        const uniqueLogs = Object.values(latestLogsByStatusAndTimestamp);
                        return uniqueLogs
                            .sort((a: any, b: any) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
                            .map((log: any, index: number) => (
                                <div className="log-entry" key={index}>
                                    <h5>{new Date(log.timestamp).toLocaleString()}</h5>
                                    <div><b>Status: {statusTranslation[log.status]} ({log.status})</b></div> {/* Use centralized statusTranslation */}

                                    {log.status === 0 && (
                                        <>
                                            <div className="email-subject-display">
                                                <strong>Ämne:</strong>
                                                <p>{sendingEmailSubject ? sendingEmailSubject : 'E-postämne saknas'}</p>
                                            </div>
                                            <div className="email-body-display">
                                                <strong>E-postinnehåll:</strong>
                                                <div dangerouslySetInnerHTML={{ __html: sendingEmailBody ? sendingEmailBody : 'E-postinnehåll saknas' }} />
                                            </div>
                                        </>
                                    )}

                                    {(log.status === 2 || log.status === 3) && log.comment && (
                                        <div className="comment-display">
                                            <strong>Kommentar:</strong>
                                            <p>{log.comment}</p>
                                        </div>
                                    )}
                                </div>
                            ));
                    })()
                ) : (
                    <p>Inga statusuppdateringar.</p>
                )}
            </div>

            {/* Modal for invoices */}
            <Modal show={showInvoicesModal} centered onHide={() => setShowInvoicesModal(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Svar och fakturaöversikt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="correctness-section">
                        <h3>Korrekthet av fakturor enligt kund:</h3>
                        {renderCorrectness(amountCorrect, "Beloppet stämmer")}
                        {renderCorrectness(quantityCorrect, "Antal stämmer")}
                        {renderCorrectness(labelCorrect, "Märkning stämmer")}

                        {/* Display all comments found in logs */}
                        {logs.filter((log: any) => log.comment).length > 0 && (
                            <div className="comment-section">
                                <h3>Kommentarer:</h3>
                                {logs
                                    .filter((log: any) => log.comment)
                                    .map((log: any, index: number) => (
                                        <div key={index} className="comment-entry">
                                            <p><strong>{statusTranslation[log.status]}:</strong> {log.comment}</p>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                    <h3 style={{ fontSize: '1.2rem', marginBottom: '4px', lineHeight: '1.2' }}>Inskickade fakturor</h3>
                    {loadingInvoices ? (
                        <p>Laddar fakturor...</p>
                    ) : (
                        <PdfTable invoiceList={invoiceList} onInvoiceClick={handleInvoiceClick} />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn button-cancel' onClick={() => setShowInvoicesModal(false)}>Stäng</button>
                    <button className='btn' onClick={handleDownloadAllPdfs}>Ladda ner alla fakturor</button>
                </Modal.Footer>
            </Modal>

            {/* Confirmation modal for reopening the link */}
            <Modal show={showConfirmModal} centered onHide={() => setShowConfirmModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Bekräfta återöppning av länk</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Är du säker på att du vill återöppna länken och förlänga utgångsdatumet med {5} dagar?
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn button-cancel' onClick={() => setShowConfirmModal(false)}>
                        <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                        Avbryt
                    </button>
                    <button className='btn' onClick={handleReopenLink} disabled={reopeningLinkLoading}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                        {reopeningLinkLoading ? 'Återöppnar...' : 'Återöppna länk'}
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmHandledModal} onHide={() => setShowConfirmHandledModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Bekräfta Åtgärd</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Är du säker på att du vill {isHandled ? "markera som ej slutförd" : "markera som slutförd"}?
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn button-cancel" onClick={() => setShowConfirmHandledModal(false)}>
                        <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                        Avbryt
                    </button>
                    <button className="btn" onClick={handleConfirmToggle}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                        {isHandled ? "Bekräfta ej slutförd" : "Bekräfta slutförd"}
                    </button>

                </Modal.Footer>
            </Modal>
            {sendingId !== null && typeof sendingId !== 'undefined' && (
                <InternalCommentsChatDock currentUserKey='test@mail.se'
    targetType='sending'
    targetId={+sendingId } />
            )}
            
        </div>
    );
};

export default FollowUpSending;
